import React, { Fragment } from 'react';
export function UserProductSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-407">
      <div className="flex flex-col w-full h-full min-h-0 relative overflow-hidden" data-id="element-408">
        {/* Top text strip */}
        <div className="flex-shrink-0 flex flex-col min-h-0 overflow-hidden" style={{
        padding: 'clamp(1.5rem, 3vw, 3rem) clamp(2rem, 6vw, 6rem) 0'
      }} data-id="element-409">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.3rem, 0.6vw, 0.5rem)',
          animationDelay: '0.1s'
        }} data-id="element-410">
            The product loop.
          </p>

          {/* Heading */}
          <h1 className="font-black tracking-tight leading-[0.95] text-white animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          marginBottom: 'clamp(0.4rem, 0.8vw, 0.6rem)',
          animationDelay: '0.15s'
        }} data-id="element-411">
            Our users make it real.
          </h1>

          {/* Body text */}
          <p className="animate-fade-slide" style={{
          color: 'rgba(255,255,255,0.45)',
          fontSize: 'var(--body-size)',
          lineHeight: '1.5',
          maxWidth: 'clamp(400px, 55vw, 700px)',
          marginBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
          animationDelay: '0.18s'
        }} data-id="element-412">
            Conversational discovery generates routes no one else has. Every
            walk creates behavioral signals that deepen the map.
          </p>
        </div>

        {/* Bottom — large phone screenshots */}
        <div className="flex-1 flex items-center justify-center relative overflow-hidden min-h-0" style={{
        padding: '0 clamp(2rem, 6vw, 6rem) clamp(2.5rem, 4vw, 4rem)',
        gap: 'clamp(1rem, 3vw, 3rem)'
      }} data-id="element-413">
          {/* Conversation screenshot */}
          <div className="relative animate-fade-slide flex items-end justify-center" style={{
          height: '100%',
          animationDelay: '0.3s'
        }} data-id="element-414">
            <img src="https://cdn.magicpatterns.com/uploads/b7HCaed9mfRsTsJHeY7SS9/Screenshot_2026-03-22_at_3.31.42_PM.png" alt="Navi conversational discovery — Hey Navi, take me somewhere new" className="h-full w-auto rounded-t-[clamp(16px,2.5vw,28px)]" style={{
            maxHeight: '100%',
            objectFit: 'contain',
            boxShadow: '0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08)'
          }} data-id="element-415" />
          </div>

          {/* Flow steps — vertical in center */}
          <div className="flex-shrink-0 flex flex-col items-center justify-center animate-fade-slide" style={{
          animationDelay: '0.4s',
          gap: 'clamp(0.4rem, 1vh, 0.75rem)',
          padding: '0 clamp(0.5rem, 1vw, 1rem)'
        }} data-id="element-416">
            {[{
            step: '01',
            label: 'Discover'
          }, {
            step: '02',
            label: 'Plan'
          }, {
            step: '03',
            label: 'Go'
          }].map((item, i) => <Fragment key={item.step} data-id="element-417">
                {i > 0 && <span style={{
              color: '#4A90D9',
              fontSize: 'var(--small-size)',
              opacity: 0.4,
              lineHeight: 1
            }} data-id="element-418">
                    ↓
                  </span>}
                <div className="flex items-center" style={{
              gap: 'clamp(0.2rem, 0.4vw, 0.35rem)'
            }} data-id="element-419">
                  <span className="font-mono" style={{
                color: '#4A90D9',
                fontSize: 'var(--small-size)',
                opacity: 0.5
              }} data-id="element-420">
                    {item.step}
                  </span>
                  <span className="font-bold text-white" style={{
                fontSize: 'var(--body-size)'
              }} data-id="element-421">
                    {item.label}
                  </span>
                </div>
              </Fragment>)}
          </div>

          {/* Navigation screenshot */}
          <div className="relative animate-fade-slide flex items-end justify-center" style={{
          height: '100%',
          animationDelay: '0.45s'
        }} data-id="element-422">
            <img src="https://cdn.magicpatterns.com/uploads/fV1rttr9LJeVj7w22Ro5Ry/Screenshot_2026-03-22_at_3.30.56_PM.png" alt="Navi turn-by-turn navigation with contextual suggestions" className="h-full w-auto rounded-t-[clamp(16px,2.5vw,28px)]" style={{
            maxHeight: '100%',
            objectFit: 'contain',
            boxShadow: '0 20px 50px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.08)'
          }} data-id="element-423" />
          </div>
        </div>
      </div>
    </section>;
}